import React, {useEffect, useRef, useState} from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {
    Breadcrumbs,
    Button,
    Collapse,
    IconButton,
    Input,
    List,
    ListItem,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {useStores} from "../../Hooks";
import {withRightClick} from "../../HOC/RightClick";
import {Loop, MoreHoriz} from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import Utility from "../../Utility";
import {InteractionPreview} from "../Editor/InteractionPreview";
import SeparatorIcon from "../../assets/img/breadcrumb-separator.svg";
import ListItemText from "@mui/material/ListItemText";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ConditionalComponent from "../Shared/ConditionalComponent";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import EllipsisContainer from "../Shared/EllipsisContainer";
import {escapeRegExp} from "../../serverClientShared/sharedUtils";
import Drag from "../DragDrop/Drag";
import Drop from "../DragDrop/Drop";
import {itemTypeEnum, quickMenuActionEnum} from "../../enums";
import {ReflexContainer, ReflexElement, ReflexSplitter} from 'react-reflex'
import 'react-reflex/styles.css'
import Paginator from "../Shared/Paginator";
import NorthIcon from '@mui/icons-material/North';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import {AnimationManagerEnum} from "../../serverClientShared/sharedEnums";
import AnimationIcon from '@mui/icons-material/Animation';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import {SelectModel} from "./SelectModel";
import {generalStore} from "../../index";
import LockOutlineIcon from '@mui/icons-material/LockOutlined';
import {ProcedureRequester} from "../../MobxStores/RequestApi/ProcedureRequester";

const nestPadding = 20;
const interactionBatchOptions = [50,10];

const renderHeading = category => {
    switch (category) {
        case 'ActionName':
            return "name"
        case 'userDefined':
            return "type"
        case 'DateCreated':
            return "creationDate"
        case 'LastUpdate':
            return "lastEdited"
        case 'LastUpdateBy':
            return "lastEditedBy"
        default:
            return ""
    }
}

const toolTipStyle= {
    backgroundColor: 'var(--windowsandmenus-normal-color)',
    border: '2px solid var(--panels-normal-color)',
    fontSize: '12px',
    color: 'var(--main-normal-color)',
    borderRadius: 'var(--menus-radius)'
}

const FolderListItem = withRightClick(observer(props => {
    const {dragStore} = useStores();
    const {folderId, nestLevel, selectedFolder, folder, handleToggleFolderOpen, setSelectedFolder, folderMap} = props;
    const {workspaceCreated} = folder;
    let animationExist = false;
    let studioAnimationExist = false;
    for (let [key, folder] of folderMap) {
        if (folder?.parentFolder?.includes(`${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`)) {
            animationExist = true;
        }
        if (folder?.parentFolder?.includes(`${AnimationManagerEnum.STUDIO_ANIMATION}`)) {
            studioAnimationExist = true;
        }
    }

    const handleIconClick = (e, callback) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.currentTarget.classList.contains('arrow-icon')) {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
        }
        callback();
    };

    const getFolderContextMenuFunctions = () => {
        return {
            [quickMenuActionEnum.RENAME]: {
                callback: () => {
                    props.handleRenameFolder(props.folder);
                    props.closeContextMenu();
                }
            },
            [quickMenuActionEnum.DELETE]: {
                callback: () => {
                    props.handleDeleteInteractionFolder(props.folder);
                    props.closeContextMenu();
                }
            }
        }
    };
    return (
        <ListItem
            onContextMenu={e => {
                if (folderId !== AnimationManagerEnum.STUDIO_ANIMATION &&
                    folderId !== `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`) {
                    props.onRightClick(e, getFolderContextMenuFunctions())
                }
            }}
            role={undefined}
            key={folderId + nestLevel}
            style={{paddingLeft: nestPadding * nestLevel}}
            className={`folder-list-item${selectedFolder === folderId ? ' selected' : ''}${folder?.userDefined ? '' : ' sdk-folder'}${dragStore.dragItemId && dragStore.dragItemId !== folderId ? ' drag-active' : ''}`}
            onClick={(e) => handleIconClick(e, () => setSelectedFolder(folderId))}
        >
            {folderId.includes(AnimationManagerEnum.ANIMATION_MANAGER) ?
                (animationExist ?
                        (folder?.open ?
                                <ExpandMoreIcon
                                    className='arrow-icon'
                                    onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleIconClick(e, () => handleToggleFolderOpen(folderId))}}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                />
                                :
                                <ChevronRightIcon
                                    className='arrow-icon'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleIconClick(e, () => handleToggleFolderOpen(folderId))}}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                />
                        )
                        : <span></span>
                )
                :
                (studioAnimationExist ?
                        (folder?.open ?
                                <ExpandMoreIcon
                                    className='arrow-icon'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleIconClick(e, () => handleToggleFolderOpen(folderId))}}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                />
                                :
                                <ChevronRightIcon
                                    className='arrow-icon'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleIconClick(e, () => handleToggleFolderOpen(folderId))}}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                />
                        )
                        : <span></span>
                )
            }

            {folderId === `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}` ||
            folderId === AnimationManagerEnum.STUDIO_ANIMATION ?
                <AnimationIcon
                    onClick={(e) => handleIconClick(e, () => setSelectedFolder(folderId))}
                    htmlColor='black'
                />
                :
                <FolderOpenIcon
                    onClick={(e) => handleIconClick(e, () => setSelectedFolder(folderId))}
                    color="black"
                />
            }

            <ListItemText
                primary={folder?.FolderName || ""}
                onClick={(e) => handleIconClick(e, () => setSelectedFolder(folderId))}
            />
            {workspaceCreated !== generalStore.workspace ?
                <Tooltip
                    placement="top"
                    title={generalStore.translate('editingLockedByParentWorkspace')}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                toolTipStyle
                            }
                        }
                    }}
                >
                    <LockOutlineIcon/>
                </Tooltip>
                : null}
        </ListItem>
    )
}));

const InteractionsEditorModal = observer(() => {
    const {modalStore, procedureStore, generalStore, projectStore, dragStore, dataStore} = useStores();

    const [searchVal, setSearchVal] = useState('');
    const [currentWidth, setCurrentWidth] = useState(window.innerWidth);
    const [selectedFolder, setSelectedFolder] = useState(`${generalStore.AnimationManagerSelectedFolder ? generalStore.AnimationManagerSelectedFolder : `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`}`
    );
    const [folderMap, setFolderMap] = useState(new Map());
    const [selectedInteraction, setSelectedInteraction] = useState('');
    const [preventBlur, setPreventBlur] = useState(true);
    const [interactionMap, setInteractionMap] = useState(new Map());
    const [interactionMenuAnchor, setInteractionMenuAnchor] = useState(null);
    const [menuInteractionId, setMenuInteractionId] = useState('');
    const [sortBy, setSortBy] = useState('LastUpdate');
    const [sortDirection, setSortDirection] = useState(-1);
    const [hover, setHover] = useState("");
    const [autocompleteAnchor, setAutocompleteAnchor] = useState(null);
    const [searchListOpen, setSearchListOpen] = useState(false);
    const [autoScroll, setAutoScroll] = useState('');
    const [sortedInteractions, setSortedInteractions] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [batchIndex, setBatchIndex] = useState(1);
    const [duplicatedAnimation, setDuplicatedAnimation] = useState(null);
    const [duplicatedAnimationFromId, setDuplicatedAnimationFromId] = useState(null)
    const [openFolderStates, setOpenFolderStates] = useState(new Map());
    const [selectedModel, setSelectedModel] = useState(null);
    const [interactionModels, setInteractionModels] = useState(new Map());

    const searchAnchorRef = useRef(null);

    const maxItems = Math.max(Math.ceil(currentWidth / 250), 4);
    const procedure = procedureStore.currentProcedure;
    const projectRef = procedureStore.currentProcedure.ProjectRef;
    const workspace = generalStore.workspace;

    useEffect(() => {
        window.addEventListener('resize', () => setCurrentWidth(window.innerWidth));
        return () => window.removeEventListener('resize', () => setCurrentWidth(window.innerWidth));
    }, []);

    useEffect(() => {
        if (!!interactionMap.size || !!sortedInteractions.length) {
            if (duplicatedAnimation !== null) {
                const interactionList = [...interactionMap.values()]
                    .filter(interaction => interaction.parentFolder === selectedFolder)
                    .sort(getSortMethod());
                const index = interactionList.findIndex(interaction => interaction.InteractiveStepID === duplicatedAnimation.InteractiveStepID);
                const [interaction] = interactionList.splice(index, 1);
                const target = interactionList.findIndex(interaction => interaction.InteractiveStepID === duplicatedAnimationFromId);
                interactionList.splice(target + 1, 0, interaction);
                setSortedInteractions(interactionList);
                updatePageLocation(interactionList)
                setDuplicatedAnimation(null)
                setDuplicatedAnimationFromId(null);
            } else {
                const interactionList = [...interactionMap.values()]
                    .filter(interaction => interaction.parentFolder === selectedFolder)
                    .sort(getSortMethod());
                setSortedInteractions(interactionList);
                updatePageLocation(interactionList);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [interactionMap, selectedFolder, autoScroll, sortBy, sortDirection]);
    useEffect(() => {
        generalStore.AnimationManagerSelectedFolder = selectedFolder;

    }, [selectedFolder]);
    useEffect(() => {
        if (generalStore.isOpenFromEditor) {
            loadInteractionModels();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generalStore.isOpenFromEditor]);

    useEffect(() => {
        generalStore.selectedAnimationModelId = selectedModel?.ProcedureIdentifier;
        if (generalStore.isOpenFromEditor && selectedModel) {
            loadFolderTree();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedModel]);

    const saveOpenFolderStates = () => {
        const openStates = new Map();
        folderMap.forEach((folder, folderId) => {
            if (folder.open) {
                openStates.set(folderId, true);
            }
        });
        setOpenFolderStates(openStates);
    };

    const updatePageLocation = (interactionList) => {
        const total = interactionList.length;
        const batch = interactionBatchOptions[batchIndex];
        let updatedPageNumber = pageNumber;
        if (total === 0) {
            updatedPageNumber = 0;
        } else if ((pageNumber * batch) + 1 > total) {
            updatedPageNumber = Math.ceil(total / batch) - 1;
        }

        if (!!autoScroll && autoScroll === selectedInteraction) {
            const selectedInteractionLocation = interactionList.findIndex(interaction => interaction.InteractiveStepID === autoScroll);
            updatedPageNumber = Math.ceil((selectedInteractionLocation + 1) / batch) - 1;
        }

        setPageNumber(updatedPageNumber);
    };

    const openDeleteInteractionDialog = interaction => {
        closeInteractionMenu();
        modalStore.modalData.interactionName = interaction.ActionName;
        modalStore.modalData.interactionId = interaction.InteractiveStepID;
        modalStore.modalData.deleteMethod = deleteInteraction;
        modalStore.isDeleteInteractionDialogOpen = true;
    }

    const deleteInteraction = async interactionId => {
        const deletedInteraction = interactionMap.get(interactionId);
        if (deletedInteraction.WorkspaceCreationName !== generalStore.workspace) {
            modalStore.showErrorMessage(generalStore.translate("youCantDeleteMirroredInteraction"));
            return;
        }
        Utility.deleteItemInMap(interactionId, interactionMap, setInteractionMap);
        await procedureStore.deleteInteraction(interactionId, deletedInteraction.ProcedureRef).then(success => {
            if (!!success) {
                modalStore.showSuccessMessage(generalStore.translate('interactionSuccessfullyDeleted'));
            } else {
                modalStore.showErrorMessage(generalStore.translate('problemDeletingInteraction'));
                Utility.setItemInMap(deletedInteraction, interactionId, interactionMap, setInteractionMap);
            }
        });
    }


    const handleDeleteInteractionFolder = folder => {
        if (folder.FolderIdentifier.split('/').length > 2) {
            if (!isAllowedToEditFolderOrInteraction()) {
                modalStore.showErrorMessage(generalStore.translate('youCantDeleteFolderOfParentFolder'));
                return;
            }
        }
        modalStore.modalData = {
            title: generalStore.translate('confirmDeleteFolder'),
            bodyText: generalStore.translate('delete') + ` ${folder.FolderName}? ` + generalStore.translate('thisWillAlsoDeleteAllItsChildren') + ', (' + generalStore.translate('foldersAndAnimations', true) + ').',
            confirmText: generalStore.translate('delete'),
            confirmActions: () => {
                if (selectedFolder === folder.FolderIdentifier) {
                    setSelectedFolder(folder.parentFolder);
                }
                const updatedFolderMap = new Map(folderMap);
                updatedFolderMap.delete(folder.FolderIdentifier);
                setFolderMap(updatedFolderMap);
                const folderPathWithoutRoot = folder.FolderIdentifier.split('/').slice(1).join('/');
                const folderPathWithoutAnimation = folderPathWithoutRoot.split('/').slice(1).join('/');
                procedureStore.deleteInteractionFolder(!folder.userDefined ? folderPathWithoutRoot : folderPathWithoutAnimation, loadFolderTree, folder.procedureId).then(success => {
                    if (!success) {
                        modalStore.showErrorMessage(generalStore.translate('problemDeletingInteractionFolder'));
                        updatedFolderMap.set(folder.FolderIdentifier, folder);
                        setFolderMap(updatedFolderMap);
                    }
                });
            },
            isDelete: true,
        }
        modalStore.isGeneralConfirmActionDialogOpen = true;
    }

    const onSearchInputTyped = e => {
        const newSearchVal = e.target.value;
        setSearchVal(newSearchVal);

        if (!newSearchVal || newSearchVal.length < 3) {
            closeSearchList();
        } else {
            openSearchList()
        }
    }

    const closeSearchList = () => {
        setSearchListOpen(false);
        setAutocompleteAnchor(null);
    }

    const openSearchList = () => {
        setSearchListOpen(true);
        setAutocompleteAnchor(searchAnchorRef.current);
    }

    const handleAddNewAnimation = async () => {
        const folderId = selectedFolder.split('/').slice(1).join('/');
        const folderIdWithoutAnimationPath = folderId.split('/').slice(1).join('/');
        if (selectedFolder.split('/').length > 2) {
            if (!isAllowedToEditFolderOrInteraction()) {
                modalStore.showErrorMessage(generalStore.translate('youCantCreateNewInteractionInsideParentFolder'));
                return;
            }
        }
        const newInteractionId = await procedureStore.createNewEmptyInteraction(folderIdWithoutAnimationPath, generalStore.isOpenFromEditor ? selectedModel : procedure);
        Utility.openInteractionEditor(workspace, generalStore.isOpenFromEditor ? selectedModel?.ProcedureIdentifier : procedure.ProcedureIdentifier, newInteractionId).then(() => {
            setSelectedInteraction('');
            modalStore.modalData = {
                title: generalStore.translate("attention"),
                bodyText: generalStore.translate('afterEditing') + ', ' + generalStore.translate('youWillNeedToRefreshToViewYourUpdatedAnimations', true) + '.',
                confirmText: generalStore.translate("refresh"),
                confirmActions: () => Utility.sleep(200).then(() => reloadInteractions(selectedFolder, true)),
                noReset: true,
            }
            modalStore.isGeneralConfirmActionDialogOpen = true;
        });
    }

    const isAllowedToEditFolderOrInteraction = () => {
        const root = selectedFolder.split('/')[2];
        for (const [key, value] of folderMap) {
            if (value.FolderIdentifier.split('/')[2] === root) {
                return value.workspaceCreated === generalStore.workspace;
            }
        }
        return true;
    }

    const handleAddNewFolder = () => {
        const inUserDefinedFolder = selectedFolder === AnimationManagerEnum.ROOT || !!folderMap.get(selectedFolder)?.userDefined;
        if (!inUserDefinedFolder) {
            modalStore.showInfoMessage(generalStore.translate('cannotCreateNewFolderInSDK'))
            return
        }
        if (selectedFolder.split('/').length > 2) {
            if (!isAllowedToEditFolderOrInteraction()) {
                modalStore.showErrorMessage(generalStore.translate('youCantCreateNewFolderInParentFolder'));
                return;
            }
        }
        modalStore.modalData = {
            ...modalStore.modalData,
            folderMap,
            folderName: '',
            isAddNew: true,
            selectedFolder,
            onConfirm: () => {
                const oldFolderMap = new Map(folderMap);
                const newFolderName = modalStore.modalData.folderName;
                const folderId = selectedFolder + '/' + newFolderName;
                const updatedFolderMap = new Map(folderMap);
                const newFolder = {
                    workspaceCreated: generalStore.workspace,
                    procedureId: generalStore.isOpenFromEditor ? selectedModel?.ProcedureIdentifier : procedure.ProcedureIdentifier,
                    open: false,
                    FolderIdentifier: folderId,
                    FolderName: modalStore.modalData.folderName,
                    userDefined: true,
                    parentFolder: selectedFolder,
                };
                updatedFolderMap.set(folderId, newFolder);
                const parentFolderIsOpen = !!folderMap.get(selectedFolder)?.open
                if (!parentFolderIsOpen) {
                    handleToggleFolderOpen(selectedFolder)
                }
                setFolderMap(updatedFolderMap);
                setSelectedInteraction('');
                const folderPathWithoutRoot = folderId.split('/').slice(1).join('/');
                const folderPathWithoutAnimation = folderPathWithoutRoot.split('/').slice(1).join('/');
                procedureStore.addNewInteractionFolder(folderPathWithoutAnimation, newFolderName, generalStore.isOpenFromEditor ? selectedModel?.ProcedureIdentifier : procedure.ProcedureIdentifier, projectStore.currentProject?.ProjectIdentifier)
                    .then(success => {
                        if (!success) {
                            setFolderMap(oldFolderMap);
                            setSelectedFolder(AnimationManagerEnum.ROOT);
                        }
                    });
            }
        }
        modalStore.isSetInteractionFolderNameModalOpen = true;
    }

    const handleRenameFolder = folder => {
        if (folder.FolderName === AnimationManagerEnum.ANIMATION_MANAGER) {
            modalStore.showInfoMessage(generalStore.translate('cannotRename') + ` ${AnimationManagerEnum.ANIMATION_MANAGER} ` + generalStore.translate('folder', true));
            return;
        }

        if (!folder.userDefined) {
            modalStore.showInfoMessage(generalStore.translate('cannotRename') + ' SDK ' + generalStore.translate('folder', true));
            return;
        }

        modalStore.modalData = {
            ...modalStore.modalData,
            folderMap,
            folderName: folder.FolderName,
            isAddNew: false,
            currentFolder: folder.parentFolder,
            onConfirm: async () => {
                const newFolderName = modalStore.modalData.folderName;
                const oldFolderPathWithoutRoot = folder.FolderIdentifier.split('/').slice(1).join('/');
                const oldFolderPathWithoutAnimationArr = oldFolderPathWithoutRoot.split('/').slice(1);
                const newFolderPathArr = [...oldFolderPathWithoutAnimationArr];
                newFolderPathArr.splice(oldFolderPathWithoutAnimationArr.length - 1, 1, newFolderName);
                const oldFolderPath = oldFolderPathWithoutAnimationArr.join('/');
                const newFolderPath = newFolderPathArr.join('/');
                procedureStore.updateInteractionFolderName(oldFolderPath, newFolderPath, loadFolderTree, folder?.procedureId).then(success => {
                    if (!success) {
                        modalStore.showErrorMessage(generalStore.translate('problemSavingUpdatedFolderName'));
                    } else {
                        const newFolderId = `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}/` + newFolderPath
                        const oldFolderPath = folder.FolderIdentifier
                        const updatedFolderMap = new Map();

                        for (const [key, value] of folderMap.entries()) {
                            if (key === oldFolderPath){
                                const newValue = {
                                    ...value,
                                    FolderIdentifier: newFolderId,
                                    FolderName: newFolderName
                                };

                                updatedFolderMap.set(newFolderId, newValue);
                            } else if (key.startsWith(oldFolderPath)) {
                                const newKey = key.replace(oldFolderPath, newFolderId);

                                const newValue = {
                                    ...value,
                                    FolderIdentifier: newKey,
                                    parentFolder: newKey.split('/').slice(0, -1).join('/')
                                };

                                updatedFolderMap.set(newKey, newValue);
                            } else {
                                updatedFolderMap.set(key, value);
                            }
                        }
                        setFolderMap(updatedFolderMap)
                        setSelectedFolder(newFolderId);
                    }
                });
            }
        }
        modalStore.isSetInteractionFolderNameModalOpen = true;
    }

    const handleToggleFolderOpen = folderId => {
        const newFolderMap = new Map(folderMap);
        if (newFolderMap.get(folderId).open) {
            recursivelyCloseFolders(newFolderMap, folderId)
        } else newFolderMap.get(folderId).open = true;
        setFolderMap(newFolderMap);
    };

    const recursivelyOpenFolders = (folderMap, folderId) => {
        if (!folderId) {
            return
        }

        const currentFolder = folderMap.get(folderId);
        if (!currentFolder || !!currentFolder.open) {
            return
        }

        currentFolder.open = true;
        folderMap.set(folderId, currentFolder);

        recursivelyOpenFolders(folderMap, currentFolder.parentFolder);
    }

    const recursivelyCloseFolders = (folderMap, folderId) => {
        if (!folderId) {
            return
        }

        const currentFolder = folderMap.get(folderId);
        if (!currentFolder) {
            return
        }

        currentFolder.open = false;
        folderMap.set(folderId, currentFolder);

        const folders = getDirectoryFolders(folderId);
        folders.forEach(folder => recursivelyCloseFolders(folderMap, folder.FolderIdentifier));
    };

    const getDirectoryFolders = folderId => {
        const folders = Array.from(folderMap.values());
        return folders.filter(folder => folder.parentFolder === folderId)
    };

    const openInteractionMenu = (e, interactionId) => {
        setInteractionMenuAnchor(e.currentTarget);
        setMenuInteractionId(interactionId);
    }

    const closeInteractionMenu = () => {
        setInteractionMenuAnchor(null);
        setMenuInteractionId("");
    }

    const duplicateInteraction = (interaction) => {
        closeInteractionMenu();
        if (interaction.WorkspaceCreationName !== generalStore.workspace) {
            modalStore.showErrorMessage(generalStore.translate('cannotDuplicateMirroredAnimation'));
            return;
        }
        procedureStore.duplicateInteractionAnimation(interaction.InteractiveStepID, interaction.ProcedureRef).then(success => {
            if (Object.keys(success).length > 0) {
                const newInteraction = success;
                newInteraction.parentFolder = interaction.parentFolder;
                newInteraction.userDefined = true;
                const entries = Array.from(interactionMap.entries());
                setDuplicatedAnimationFromId(interaction.InteractiveStepID);
                const keyToFind = interaction.InteractiveStepID;
                const indexOfKey = entries.findIndex(([key, value]) => key === keyToFind);
                entries.splice(indexOfKey, 0, [newInteraction.InteractiveStepID, newInteraction]);

                if (indexOfKey + 1 < entries.length) {
                    const originalItem = entries.splice(indexOfKey + 1, 1)[0];
                    entries.splice(indexOfKey + 2, 0, originalItem);
                }
                setDuplicatedAnimation(newInteraction);
                setInteractionMap(new Map(entries));
                procedureStore.procedureUserDefinedInteractions.set(newInteraction.InteractiveStepID, newInteraction);
            } else {
                modalStore.showErrorMessage(generalStore.translate('problemDuplicatingInteraction'));
            }
        })
    }

    const openRenameInteraction = (interaction) => {
        if (interaction.WorkspaceCreationName !== generalStore.workspace) {
            modalStore.showErrorMessage(generalStore.translate('cannotRenameParentInteraction'));
            return;
        }
        closeInteractionMenu();
        modalStore.modalData = {
            ...modalStore.modalData,
            interactionMap,
            interactionName: interaction.ActionName,
            onConfirm: () => {
                const oldInteractionMap = new Map(interactionMap);
                const newInteractionName = modalStore.modalData.interactionName;
                const updatedInteractionMap = new Map(interactionMap);
                interaction.ActionName = newInteractionName;
                updatedInteractionMap.set(interaction.InteractiveStepID, interaction);
                setInteractionMap(updatedInteractionMap);
                procedureStore.updateInteraction(interaction).then(success => {
                    if (!success) {
                        modalStore.showErrorMessage(generalStore.translate('problemSavingRenamedInteraction'));
                        setInteractionMap(oldInteractionMap);
                    } else procedureStore.procedureUserDefinedInteractions.set(interaction.InteractiveStepID, interaction)
                });
            }
        }
        modalStore.isSetInteractionNameModalOpen = true;
    }
    const openInteractionUsages = async(interaction) => {
        const {procedures, isUsedInChildren} = await ProcedureRequester.getProcedureUsages(generalStore.workspace, interaction.InteractiveStepID, projectStore.currentProject?.ProjectIdentifier);
        modalStore.modalData = {
            ...modalStore.modalData,
            interactionMap,
            interactionName: interaction.ActionName,
            interactionId: interaction.InteractiveStepID,
            proceduresUsages: procedures,
            isUsedInChildren,
        }

        modalStore.isInteractionUsagesModalOpen = true;
    }


    const goToSearchItem = (item, itemIsFolder = false) => {
        const parentFolderId = item?.parentFolder || AnimationManagerEnum.ROOT;
        recursivelyOpenFolders(folderMap, parentFolderId);
        if (!itemIsFolder) {
            setAutoScroll(item.InteractiveStepID);
            setSelectedInteraction(item.InteractiveStepID);
        }
        setSelectedFolder(parentFolderId);
        closeSearchList();
    }

    const dragItemIsParent = (dropFolderId) => {
        const dragId = dragStore.dragItemId || "";
        if (folderIsAlreadyDragItemParent(dropFolderId)) {
            return true
        } else if (!interactionMap.has(dragId)) {
            return new RegExp(`^${dragId}.*$`, 'i').test(dropFolderId);
        } else return false
    }

    const folderIsAlreadyDragItemParent = dropFolderId => {
        const dragId = dragStore.dragItemId || "";
        const dragItem = interactionMap.get(dragId) || folderMap.get(dragId) || {};
        return dragItem.parentFolder === dropFolderId;
    }

    const searchPrev = () => setPageNumber(pageNumber - 1);

    const searchNext = () => setPageNumber(pageNumber + 1);

    const getMin = () => pageNumber * interactionBatchOptions[batchIndex] + 1;

    const getMax = () => Math.min((pageNumber + 1) * interactionBatchOptions[batchIndex], sortedInteractions.length);

    const handleSelectBatchNum = event => {
        setBatchIndex(event.target.value)
        setPageNumber(0);
    }

    // In InteractionsEditorModal.js

    const finishDragFolder = (destinationFolderPath, currentFolderPath) => {
        if (destinationFolderPath === AnimationManagerEnum.ROOT) {
            return;
        }

        saveOpenFolderStates();

        if (currentFolderPath === `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}` ||
            currentFolderPath === `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.STUDIO_ANIMATION}`) {
            return;
        }

        const currentIsSelectedFolder = currentFolderPath === selectedFolder;
        let currentPathWithoutRoot = currentFolderPath.split('/').slice(1).join('/');
        let destinationPathWithoutRoot = destinationFolderPath.split('/').slice(1).join('/');

        if ((currentPathWithoutRoot.includes(AnimationManagerEnum.STUDIO_ANIMATION) && destinationPathWithoutRoot.includes(AnimationManagerEnum.ANIMATION_MANAGER))
            || (currentPathWithoutRoot.includes(AnimationManagerEnum.ANIMATION_MANAGER) && destinationPathWithoutRoot.includes(AnimationManagerEnum.STUDIO_ANIMATION))) {
            return;
        }

        // Update folder structure in UI immediately
        const updatedFolderMap = new Map(folderMap);
        const currentFolder = updatedFolderMap.get(currentFolderPath);

        if (currentFolder) {
            const moveFolder = (oldPath, newParentPath) => {
                const folder = updatedFolderMap.get(oldPath);
                if (!folder) return;

                const folderName = folder.FolderName;
                const newPath = `${newParentPath}/${folderName}`;

                updatedFolderMap.delete(oldPath);
                updatedFolderMap.set(newPath, {
                    ...folder,
                    FolderIdentifier: newPath,
                    parentFolder: newParentPath
                });

                Array.from(updatedFolderMap.entries()).forEach(([path, childFolder]) => {
                    if (childFolder.parentFolder === oldPath) {
                        moveFolder(path, newPath);
                    }
                });

                interactionMap.forEach((interaction, id) => {
                    if (interaction.parentFolder === oldPath) {
                        interaction.parentFolder = newPath;
                        interaction.InteractiveIOPath = newPath.split('/').slice(2).join('/');
                    }
                });
            };

            moveFolder(currentFolderPath, destinationFolderPath);

            setFolderMap(updatedFolderMap);

            if (currentIsSelectedFolder) {
                const newPath = `${destinationFolderPath}/${currentFolder.FolderName}`;
                setSelectedFolder(newPath);
            }

            if (currentPathWithoutRoot.includes(AnimationManagerEnum.ANIMATION_MANAGER)) {
                currentPathWithoutRoot = currentPathWithoutRoot.split('/').slice(1).join('/');
                destinationPathWithoutRoot = destinationPathWithoutRoot.split('/').slice(1).join('/');
            }

            procedureStore.updateInteractionFolders(currentPathWithoutRoot, destinationPathWithoutRoot, () => {
            });
        }

        Utility.sleep(100).then(() => {
            const restoredFolderMap = new Map(updatedFolderMap);
            openFolderStates.forEach((_, folderId) => {
                const newFolderId = Array.from(restoredFolderMap.keys()).find(key =>
                    key.endsWith(folderId.split('/').pop()));
                if (newFolderId && restoredFolderMap.has(newFolderId)) {
                    restoredFolderMap.get(newFolderId).open = true;
                }
            });
            setFolderMap(restoredFolderMap);
        });
    };

    const finishDragInteraction = async (destinationFolderPath, dragInteraction) => {
        const destinationFolderPathWithoutRoot = destinationFolderPath.split('/').slice(1).join('/');
        dragInteraction.InteractiveIOPath = destinationFolderPathWithoutRoot.split('/').slice(1).join('/');
        dragInteraction.parentFolder = destinationFolderPath;
        procedureStore.procedureUserDefinedInteractions.set(dragInteraction.InteractiveStepID, dragInteraction);
        const updatedInteractionMap = new Map(interactionMap);
        updatedInteractionMap.set(dragInteraction.InteractiveStepID, dragInteraction);
        setInteractionMap(updatedInteractionMap);
        try {
            await procedureStore.updateInteraction(dragInteraction);
        } catch (e) {
            console.error('Failed to save interaction after move:', e);
            modalStore.showErrorMessage(generalStore.translate('problemMovingInteraction'));
        }
    }

    const editInteraction = (interaction) => {
        if (interaction.WorkspaceCreationName !== generalStore.workspace) {
            modalStore.showErrorMessage(generalStore.translate("youCantEditMirroredInteraction"));
            return;
        }
        Utility.openInteractionEditor(workspace, generalStore.isOpenFromEditor ? selectedModel.ProcedureIdentifier : procedure.ProcedureIdentifier, interaction.InteractiveStepID).then(() => {
            modalStore.modalData = {
                title: generalStore.translate("attention"),
                bodyText: generalStore.translate('afterEditing') + ', ' + generalStore.translate('youWillNeedToRefreshToViewYourUpdatedAnimations', true) + '.',
                confirmText: generalStore.translate("refresh"),
                confirmActions: () => Utility.sleep(200).then(() => reloadInteractions(selectedFolder, true)),     //wait until GeneralConfirmActionDialog closeModel() has finished
                noReset: true,
            }
            modalStore.isGeneralConfirmActionDialogOpen = true;
        })
    }

    const renderInteractionOptionsMenu = (interaction, isWorkspaceInteraction) => {
        const interactionId = interaction.InteractiveStepID;
        return (
            <div
                className="pay-per-click-menu-container"
            >
                <MoreHoriz
                    onClick={(e) => openInteractionMenu(e, interactionId)}
                    name="pay-per-click-three-dot-icon"
                />
                <Menu
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: generalStore.langDir === 'rtl' ? "left" : "right",
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: generalStore.langDir === 'rtl' ? "left" : "right",
                    }}
                    open={!!interactionMenuAnchor && menuInteractionId === interactionId}
                    onClose={closeInteractionMenu}
                    anchorEl={interactionMenuAnchor}
                    className='pay-per-click-menu'
                    disableAutoFocusItem
                    getContentAnchorEl={null}
                >
                    {!interaction.userDefined || !isWorkspaceInteraction || interaction.IsGuides ? (
                        <MenuItem
                            className='dropdown-item'
                            onClick={() => openInteractionUsages(interaction)}
                        >
                            <span>View usages</span>
                        </MenuItem>
                    ) : (
                        [
                            <MenuItem
                                key="edit"
                                className='dropdown-item'
                                onClick={() => editInteraction(interaction)}
                            >
                                <span>{generalStore.translate('edit')}</span>
                            </MenuItem>,

                            <MenuItem
                                key="duplicate"
                                className='dropdown-item'
                                onClick={() => duplicateInteraction(interaction)}
                            >
                                <span>{generalStore.translate('duplicate')}</span>
                            </MenuItem>,

                            <MenuItem
                                key="rename"
                                className='dropdown-item'
                                onClick={() => openRenameInteraction(interaction)}
                            >
                                <span>{generalStore.translate('rename')}</span>
                            </MenuItem>,

                            <MenuItem
                                key="usages"
                                className='dropdown-item'
                                onClick={() => openInteractionUsages(interaction)}
                            >
                                <span>View usages</span>
                            </MenuItem>,

                            <MenuItem
                                key="delete"
                                className='dropdown-item warning'
                                onClick={() => openDeleteInteractionDialog(interaction)}
                            >
                                <DeleteIcon className='delete-icon'/>
                                <span>{generalStore.translate('delete')}</span>
                            </MenuItem>
                        ]
                    )}
                </Menu>

            </div>
        );
    }

    const renderTitleAndSortIcon = (category) => {
        const selectSort = () => {
            if (sortBy === category) {
                setSortDirection(sortDirection * -1);
            } else setSortBy(category);
        }

        return (
            <div
                className={`child ${category} ${sortBy === category ? " selected" : ""}`}
                onClick={selectSort}
            >
                <div className="header-title">{generalStore.translate(renderHeading(category))}</div>
                <ConditionalComponent if={sortBy === category}>
                    {sortDirection === -1
                        ? <ArrowDownwardIcon/>
                        : <ArrowUpwardIcon/>
                    }
                </ConditionalComponent>
                <ConditionalComponent if={sortBy !== category}>
                    <div className="empty-box"/>
                </ConditionalComponent>
            </div>
        )
    }

    const getSortMethod = () => {
        const sortAscending = sortDirection > 0;

        let sortMethod;
        switch (sortBy) {
            case 'ActionName':
                sortMethod = Utility.buildSortMethod(sortAscending, "ActionName");
                break;
            case 'userDefined':
                sortMethod = Utility.buildSortMethod(sortAscending, "userDefined");
                break;
            case 'DateCreated' :
                sortMethod = (listItemA, listItemB) => sortAscending
                    ? new Date(Number(listItemA.DateCreated)) - new Date(Number(listItemB.DateCreated))
                    : new Date(Number(listItemB.DateCreated)) - new Date(Number(listItemA.DateCreated));
                break;
            case 'LastUpdate' :
                sortMethod = (listItemA, listItemB) => sortAscending
                    ? new Date(Number(listItemA.LastUpdate)) - new Date(Number(listItemB.LastUpdate))
                    : new Date(Number(listItemB.LastUpdate)) - new Date(Number(listItemA.LastUpdate));
                break;
            case 'LastUpdateBy':
                sortMethod = (listItemA, listItemB) => {
                    return !sortAscending
                        ? Utility.getUserFullName(listItemA.LastUpdateBy).toLowerCase() < Utility.getUserFullName(listItemB.LastUpdateBy).toLowerCase() ? 1 : -1
                        : Utility.getUserFullName(listItemB.LastUpdateBy).toLowerCase() > Utility.getUserFullName(listItemA.LastUpdateBy).toLowerCase() ? -1 : 1;
                }
                break;
            default:
                sortMethod = () => {
                };
        }
        return sortMethod
    }


    const renderTableRows = (interactionList) => {
        const batch = interactionBatchOptions[batchIndex];
        const paginatedInteractions = interactionList.slice(pageNumber * batch, (pageNumber + 1) * batch);

        const handleAddInteractionFromFlowEditor = (interaction) => {
            const arr = [];
            arr.push(interaction)
            generalStore.onSaveInteractions = true;
            generalStore.selectedInteractions = [...arr]
            modalStore.isSetInteractionsEditorModalOpen = false;
        }

        return paginatedInteractions.map((interaction, i) => {
            const isWorkspaceInteraction = interaction.WorkspaceCreationName === generalStore.workspace;
            const interactionId = interaction.InteractiveStepID;
            return (
                <Drag
                    key={interactionId + i}
                    itemId={interactionId}
                    itemType={itemTypeEnum.INTERACTION}
                    onFinishDrag={(destinationFolderPath) => finishDragInteraction(destinationFolderPath, interaction)}
                    disabled={!interaction.userDefined}
                >
                    <div
                        id={`interaction-row-${interactionId}`}
                        className={`table-row${selectedInteraction === interactionId ? ' selected' : ''}${hover === interactionId ? ' hovered' : ''}`}
                        onMouseEnter={() => {
                            setHover(interactionId);
                            setPreventBlur(true);
                        }}
                        onMouseLeave={() => {
                            setHover("");
                            setPreventBlur(false);
                        }}
                    >
                        {generalStore.isOpenFromEditor && (
                            <div>
                                <AddIcon className='add-interactions-from-flow-editor' onClick={(e) => {
                                    e.stopPropagation();
                                    handleAddInteractionFromFlowEditor(interaction)
                                }}/>
                            </div>
                        )}
                        <Tooltip title={interaction.ActionName}  placement="top" sx={toolTipStyle}>
                            <div
                                className={`table-cell interaction-name ${interaction.userDefined ? ' grab' : ''}`}
                                onClick={() => setSelectedInteraction(interactionId)}
                            >
                                    {interaction.ActionName}
                            </div>
                        </Tooltip>
                        <div
                            className={`table-cell${interaction.userDefined ? ' grab' : ''}`}
                            onClick={() => setSelectedInteraction(interactionId)}
                        >
                            {interaction.userDefined ? generalStore.translate('animationBuilder') : '3D ' + generalStore.translate('studio')}
                        </div>
                        <div
                            className={`table-cell${interaction.userDefined ? ' grab' : ''}`}
                            onClick={() => setSelectedInteraction(interactionId)}
                        >
                            {Utility.renderFullDate(Number(interaction.DateCreated))}
                        </div>
                        <div
                            className={`table-cell${interaction.userDefined ? ' grab' : ''}`}
                            onClick={() => setSelectedInteraction(interactionId)}
                        >
                            {Utility.renderFullDate(Number(interaction.LastUpdate))}
                        </div>
                        <div
                            className={`table-cell${interaction.userDefined ? ' grab' : ''}`}
                            onClick={() => setSelectedInteraction(interactionId)}
                        >
                            {!interaction.importedFromWorkspace ? Utility.getUserFullName(interaction.LastUpdateBy) : generalStore.translate('Parent workspace')}
                        </div>
                        <div className="table-cell interactive">
                            <InteractionPreview interactionPreviewLink={interaction.InteractionPreviewLink}/>
                        </div>
                        <div className="table-cell interactive">
                            {!(interaction.userDefined && isWorkspaceInteraction && !interaction.IsGuides) &&
                                <Tooltip
                                    placement="top"
                                    title={generalStore.translate('thisAnimationIsReadOnly,EditingIsDisabled')}
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                backgroundColor: 'var(--windowsandmenus-normal-color)',
                                                border: '2px solid var(--panels-normal-color)',
                                                fontSize: '12px',
                                                color: 'var(--main-normal-color)',
                                                borderRadius: 'var(--menus-radius)'
                                            }
                                        }
                                    }}
                                >
                                    <p className='flex justify-center !mb-0 -ml-4 bg-panels-normal p-1.5 rounded-menu text-main-normal'>read-only</p>
                                </Tooltip>}
                        </div>
                        <div className="table-cell interactive">
                            {interaction.userDefined &&
                                renderInteractionOptionsMenu(interaction, isWorkspaceInteraction)}
                        </div>
                    </div>
                </Drag>
            )
        });
    }

    const renderPaginationMenu = () => {
        return (
            <div className="pagination-menu">
                <Paginator
                    onPreviousClick={searchPrev}
                    onNextClick={searchNext}
                    currentMin={getMin()}
                    currentMax={getMax()}
                    total={sortedInteractions.length}
                />
                <TextField
                    value={batchIndex}
                    className="select-batch-num"
                    select
                    onChange={handleSelectBatchNum}
                    variant="outlined"
                >
                    {interactionBatchOptions.map((option, i) => (
                        <MenuItem key={option} value={i} className="comments-batch-num">
                            {option}
                        </MenuItem>
                    ))}
                </TextField>
                <Typography
                    component="span"
                    variant="subtitle2"
                    color="textPrimary"
                >
                </Typography>
            </div>
        )
    }

    const renderInteractionsList = () => {
        return (
            <div
                className="pane-content table-container"
                onClick={() => !preventBlur && setSelectedInteraction('')}
            >
                <div className="table-header sticky">
                    <div
                        className="table-row row-header"
                        style={generalStore.isOpenFromEditor ? { marginLeft: '20px' } : {}}
                        onMouseEnter={() => setPreventBlur(true)}
                        onMouseLeave={() => setPreventBlur(false)}
                    >
                        <div className="table-cell head interaction-name">{renderTitleAndSortIcon("ActionName")}</div>
                        <div className="table-cell head">{renderTitleAndSortIcon("userDefined")}</div>
                        <div className="table-cell head">{renderTitleAndSortIcon("DateCreated")}</div>
                        <div className="table-cell head">{renderTitleAndSortIcon("LastUpdate")}</div>
                        <div className="table-cell head">{renderTitleAndSortIcon("LastUpdateBy")}</div>
                        <div className="table-cell head interactive"/>
                        <div className="table-cell head interactive"/>
                        <div className="table-cell head interactive"/>
                    </div>
                </div>
                <div className="table-body special-scroll" aria-label="sticky table">
                    {renderTableRows(sortedInteractions)}
                </div>
            </div>
        );
    }

    const renderFolder = (folderId, nestLevel) => {
        if (!folderId) {
            return
        }
        const folder = folderMap.get(folderId);
        return (
            <React.Fragment key={folderId}>
                <Drag
                    itemId={folderId}
                    itemType={itemTypeEnum.INTERACTION_FOLDER}
                    onFinishDrag={(destinationFolderPath) => finishDragFolder(destinationFolderPath, folderId)}
                    onMouseEnter={() => setPreventBlur(true)}
                    onMouseLeave={() => setPreventBlur(false)}
                    disabled={!folder?.userDefined}
                >
                    <Drop itemId={folderId} isDisabled={!folder?.userDefined || dragItemIsParent(folderId)}>
                        <FolderListItem
                            folderId={folderId}
                            nestLevel={nestLevel}
                            selectedFolder={selectedFolder}
                            folder={folder}
                            handleToggleFolderOpen={handleToggleFolderOpen}
                            setSelectedFolder={setSelectedFolder}
                            handleRenameFolder={handleRenameFolder}
                            handleDeleteInteractionFolder={handleDeleteInteractionFolder}
                            folderMap={folderMap}
                        />
                    </Drop>
                </Drag>
                <Collapse in={!!folder?.open} timeout="auto" unmountOnExit>
                    {getDirectoryFolders(folderId).map(f => renderFolder(f.FolderIdentifier, nestLevel + 1))}
                </Collapse>
            </React.Fragment>
        )
    };


    const createAnimationManagerFolder = (folders) => {
        const folder = folders.find(f => f.FolderName === AnimationManagerEnum.ANIMATION_MANAGER);
        const basePath = AnimationManagerEnum.ROOT;

        if (!folder) {
            const newFolder = {
                workspaceCreated: generalStore.workspace,
                procedureId: selectedModel?.ProcedureIdentifier || '',
                open: false,
                FolderIdentifier: `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`,
                FolderName: AnimationManagerEnum.ANIMATION_MANAGER,
                userDefined: true,
                parentFolder: AnimationManagerEnum.ROOT,
            };

            setFolderMap((prevState) => {
                const newMap = new Map();

                prevState.forEach((value, key) => {
                    if (key.startsWith(basePath) && key.startsWith(key.slice(basePath.length)) !== '3D') {
                        const newPath = `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}${key.slice(basePath.length)}`;
                        const parentFolder = newPath.split('/').slice(0, -1).join('/');
                        const updatedFolder = {
                            ...value,
                            FolderIdentifier: newPath,
                            parentFolder,
                        };
                        newMap.set(newPath, updatedFolder);
                    } else {
                        newMap.set(key, value);
                    }
                });

                newMap.set(newFolder.FolderIdentifier, newFolder);

                return newMap;
            });

            return [...folders, newFolder];
        }

        return folders;
    };


    const renderFolderTree = () => {
        const folders = getDirectoryFolders(AnimationManagerEnum.ROOT);
        const rootFolders = createAnimationManagerFolder(folders)
        return (
            <List
                component="nav"
                className="pane-content"
                style={dragStore.dragItemId ? {overflowY: 'visible'} : null}
                onClick={() => {
                    if (!preventBlur) {
                        setSelectedInteraction('');
                    }
                }}
            >
                {rootFolders.map(f => renderFolder(f.FolderIdentifier, 0))}
            </List>
        )
    }

    const buildSearchResults = () => {
        if (searchVal.length < 3) {
            return null
        }
        const menuItems = [];

        const searchLower = escapeRegExp(searchVal.toLowerCase().trim());
        const regexSearchStr = new RegExp(searchLower, "i");

        interactionMap.forEach(interaction => {
            const interactionName = interaction.ActionName || "";
            if (interactionName.search(regexSearchStr) >= 0) {
                menuItems.push(
                    <MenuItem
                        onClick={() => goToSearchItem(interaction)}
                        className='search-menu-item'
                    >
                        <EllipsisContainer value={interactionName}>
                            <div className='search-menu-item-start'>
                                {interactionName}
                            </div>
                        </EllipsisContainer>
                    </MenuItem>
                )
            }
        });

        folderMap.forEach(folder => {
            const folderName = folder?.FolderName;
            if (!!folderName && folderName !== AnimationManagerEnum.ROOT && folderName.search(regexSearchStr) >= 0) {
                menuItems.push(
                    <MenuItem
                        onClick={() => goToSearchItem(folder, true)}
                        className='search-menu-item'
                    >
                        <EllipsisContainer value={folderName}>
                            <div className='search-menu-item-start'>
                                <FolderOpenIcon/> {folderName}
                            </div>
                        </EllipsisContainer>
                    </MenuItem>
                )
            }
        });

        return menuItems;
    }

    const renderSearchInput = () => {
        const menuItems = buildSearchResults();
        return (
            <>
                <Input
                    className="search-projects"
                    placeholder={generalStore.translate('search')}
                    value={searchVal}
                    onChange={onSearchInputTyped}
                    disableUnderline
                    onMouseEnter={() => setPreventBlur(true)}
                    onMouseLeave={() => setPreventBlur(false)}
                />
                <div ref={searchAnchorRef} className='search-anchor'/>
                <Menu
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: generalStore.langDir === 'ltr' ? 'left' : 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: generalStore.langDir === 'ltr' ? 'left' : 'right',
                    }}
                    disableAutoFocus
                    disableEnforceFocus
                    disableAutoFocusItem
                    open={searchListOpen && !!menuItems?.length}
                    onClose={closeSearchList}
                    anchorEl={autocompleteAnchor}
                    variant='menu'
                    autoFocus={false}
                    PaperProps={{
                        className: 'autocomplete-menu interaction-search special-scroll'
                    }}
                    onMouseEnter={() => setPreventBlur(true)}
                    onMouseLeave={() => setPreventBlur(false)}
                >
                    {menuItems}
                </Menu>
            </>
        )
    }

    const renderBreadCrumbs = () => {
        const separator = <img src={SeparatorIcon} alt=''/>;
        const pathArr = selectedFolder.split('/');
        const breadCrumbs = [];

        // if (!selectedFolder || (!!folderMap.get(selectedFolder) && !folderMap.get(selectedFolder).userDefined)) {
        //     breadCrumbs.push(
        //         <Drop key={AnimationManagerEnum.ROOT} itemId={AnimationManagerEnum.ROOT} isDisabled={folderIsAlreadyDragItemParent(AnimationManagerEnum.ROOT)}>
        //             <div className="breadcrumb" onClick={() => setSelectedFolder(`${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`)}>
        //                 {/*{generalStore.translate('animation')}*/}
        //             </div>
        //         </Drop>
        //     );
        // }
        if (!!selectedFolder && selectedFolder !== AnimationManagerEnum.ROOT) {
            pathArr.forEach((folderName, i) => {
                const folderId = pathArr.slice(0, i + 1).join('/');
                if (folderName !== AnimationManagerEnum.ROOT) {
                    breadCrumbs.push(
                        <Drop
                            itemId={folderId}
                            isDisabled={(folderId !== AnimationManagerEnum.ROOT && (!!folderMap.get(selectedFolder) && !folderMap.get(selectedFolder).userDefined)) || dragItemIsParent(folderId)}
                            key={folderName + i}
                        >
                            <div style={{color: `${selectedFolder === folderId ? 'black' : '#2f80edff'}`}}
                                 className="breadcrumb" onClick={() => setSelectedFolder(folderId)}>
                                {folderName}
                            </div>
                        </Drop>
                    );
                }
            })
        }

        return (
            <Breadcrumbs separator={separator} maxItems={maxItems}>{breadCrumbs}</Breadcrumbs>
        )
    }

    function renderAddItemMenu() {
        const inUserDefinedFolder = selectedFolder === `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`
            || !!folderMap.get(selectedFolder)?.userDefined;

        return inUserDefinedFolder ? <div>
            <Button disabled={!inUserDefinedFolder} style={{backgroundColor: '#2F80ED', color: 'white'}}
                    onClick={(e) => {
                        generalStore.forceStopDataPoll = true;
                        handleAddNewAnimation();
                    }}>
                <AddIcon/> {generalStore.translate('newAnimation')}
            </Button>
            <Button onClick={handleAddNewFolder} disabled={!inUserDefinedFolder}><CreateNewFolderIcon/></Button>
        </div> : <span></span>
    }

    const handleClickSelectFolder = () => {
        for (let i = selectedFolder.length - 1; i >= 0; i--) {
            if (selectedFolder[i] === '/') {
                setSelectedFolder(selectedFolder.slice(0, i));
                return;
            }
        }
        setSelectedFolder(AnimationManagerEnum.ROOT)
    }

    const renderBody = () => {
        const handleSelect = (e) => {
            setSelectedModel(e.target.value);
            setSelectedFolder(`${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`);
            setPageNumber(0)
        }
        return (
            <div className="interaction-dashboard-container">
                <div className="interaction-dashboard-header"
                     onClick={() => !preventBlur && setSelectedInteraction('')}>
                    <div className="interaction-header-actions-container">
                        <Tooltip title={generalStore.translate('refreshInteractions')}>
                            <IconButton className='refresh-interactions'
                                        onClick={() => reloadInteractions(selectedFolder, true)}>
                                <Loop/>
                            </IconButton>
                        </Tooltip>
                        <ConditionalComponent if={!!generalStore.isOpenFromEditor && interactionModels.size > 1}>
                            <SelectModel
                                selectedModel={selectedModel}
                                onSelect={handleSelect}
                                interactionModels={interactionModels}
                            />
                        </ConditionalComponent>
                        {renderSearchInput()}
                    </div>
                    <div style={{display: 'flex', marginLeft: '12px', marginTop: '5px'}}>
                        {(selectedFolder !== AnimationManagerEnum.ROOT && selectedFolder !== `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`
                                && selectedFolder !== AnimationManagerEnum.STUDIO_ANIMATION) &&
                            <NorthIcon onClick={() => handleClickSelectFolder()}
                                       style={{color: '#7F7F7F', cursor: 'pointer'}}/>}
                        {renderBreadCrumbs()}
                    </div>
                </div>
                <ReflexContainer className="interaction-dashboard-main" orientation="vertical">
                    <ReflexElement
                        className="left-pane interaction-folder-container special-scroll"
                        maxSize={currentWidth * 0.35}
                    >
                        {renderFolderTree()}
                    </ReflexElement>
                    <ReflexSplitter/>
                    <ReflexElement className="right-pane interaction-table-container" flex={0.75}>
                        <div
                            className='header-animation'
                            // style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center',position:'fixed'}}
                        >
                            {renderAddItemMenu()}
                            <div>
                                {renderPaginationMenu()}
                            </div>
                        </div>
                        {renderInteractionsList()}
                    </ReflexElement>
                </ReflexContainer>
            </div>
        )
    }

    const addInteraction = (interaction, parentFolderId, initInteractionMap, initFolderMap, userDefined = false) => {
        if (!interaction) {
            return
        }
        let parentFolder = parentFolderId;
        if (parentFolder.includes(AnimationManagerEnum.ROOT)) {
            parentFolder = `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`;
        }
        let pathArr = [];
        if (!!interaction.InteractiveIOPath?.length) {
            let pathStr = interaction.InteractiveIOPath
            if (pathStr[pathStr.length - 1] === "/") {
                pathStr = pathStr.slice(0, -1);
            }
            pathArr = pathStr.split("/");
            parentFolder += "/" + pathStr;
        }


        const interactionIsFakeFolder = userDefined && !interaction.InteractionData;
        if (!interactionIsFakeFolder) {
            initInteractionMap.set(interaction.InteractiveStepID, {
                ...interaction,
                userDefined,
                parentFolder
            });
        }

        let folderNum = pathArr.length;

        while (folderNum > 0) {
            const folderId = parentFolderId + "/" + pathArr.join('/');
            const folderName = pathArr.pop();
            let folder = {
                workspaceCreated: interaction.WorkspaceCreationName,
                procedureId: interaction.ProcedureRef,
                open: false,
                FolderIdentifier: folderId,
                FolderName: folderName,
                userDefined,
            }
            if (folderNum === 1) {
                folder.parentFolder = parentFolderId;
            } else folder.parentFolder = parentFolderId + "/" + pathArr.join('/');

            if (!initFolderMap.has(folderId)) {
                initFolderMap.set(folderId, folder);
            }
            --folderNum;
        }
    }

    const loadFolderTree = (keepCurrentOpenState = false) => {
        const procedureInteractions = generalStore.isOpenFromEditor
            ? (projectStore.currentProject?.userDefinedInteractions
                    ? Array.from(projectStore.currentProject.userDefinedInteractions.values())
                        .filter(interaction => interaction.ProcedureRef === selectedModel?.ProcedureIdentifier)
                    : []
            )
            : procedureStore.procedureUserDefinedInteractions;

        const projectInteractionMap = generalStore.isOpenFromEditor
            ? projectStore.currentProject?.interactions
            : projectStore.currentProjectInteractionsMap;
        const initFolderMap = new Map([[AnimationManagerEnum.ROOT, {open: false}]]);
        const initInteractionMap = new Map();

        if (!!projectInteractionMap?.size) {
            initFolderMap.set(AnimationManagerEnum.STUDIO_ANIMATION, {
                open: false,
                FolderIdentifier: AnimationManagerEnum.STUDIO_ANIMATION,
                FolderName: AnimationManagerEnum.STUDIO_ANIMATION,
                parentFolder: AnimationManagerEnum.ROOT,
                isSDK: true
            });
            projectInteractionMap.forEach(interaction => {
                addInteraction(interaction, AnimationManagerEnum.STUDIO_ANIMATION, initInteractionMap, initFolderMap);
            });
        }

        procedureInteractions?.forEach(interaction => {
            addInteraction(interaction, AnimationManagerEnum.ROOT, initInteractionMap, initFolderMap, true)
        });

        initFolderMap.forEach((folder, key) => {
            if (keepCurrentOpenState) {
                folder.open = folderMap.get(key)?.open;
                initFolderMap.set(key, folder);
            }
        })

        if (keepCurrentOpenState) {
            openFolderStates.forEach((_, folderId) => {
                if (initFolderMap.has(folderId)) {
                    initFolderMap.get(folderId).open = true;
                }
            });
        }

        setInteractionMap(initInteractionMap);
        setFolderMap(initFolderMap);
        return initFolderMap
    }


    const loadInteractionModels = () => {
        const interactionModelIds = [...procedureStore.currentProcedure.ThreeDModelsConnected];
        const connectedModels = new Map();
        if (!!interactionModelIds.length) {
            const projectProceduresMap = dataStore.projectsProceduresMap.get(projectRef);
            if (!projectProceduresMap) {
                return null;
            }
            projectProceduresMap.forEach(model => {
                if (!!interactionModelIds.includes(model.ProcedureIdentifier)) {
                    connectedModels.set(model.ProcedureIdentifier, model);
                }
            })
            setInteractionModels(connectedModels);
            const shouldSetSelectedModel = !selectedModel || !interactionModelIds.includes(selectedModel.ProcedureIdentifier);
            if (connectedModels?.size && shouldSetSelectedModel) {
                const firstModel = Array.from(connectedModels.values())[0];
                setSelectedModel(firstModel);
            }
            return connectedModels
        } else return null
    }

    const reloadInteractions = async (selectedFolder = AnimationManagerEnum.ROOT, keepCurrentOpenState = false) => {
        generalStore.isLoaderOpen = true;
        setSelectedInteraction('');
        setSelectedFolder(`${generalStore.AnimationManagerSelectedFolder? generalStore.AnimationManagerSelectedFolder : `${AnimationManagerEnum.ROOT}/${AnimationManagerEnum.ANIMATION_MANAGER}`}`
        );
        await Promise.all([procedureStore.getUserDefinedInteractions(generalStore.isOpenFromEditor ? selectedModel : procedure, !!generalStore.isOpenFromEditor), projectStore.loadProjectInteractions(null, procedure.ProjectRef, false)]);
        loadFolderTree(keepCurrentOpenState);
        generalStore.isLoaderOpen = false;
    }

    const onEnter = async () => {
        generalStore.forceStopDataPoll = true;
        setSearchListOpen(false);
        setSearchVal('');
        setAutocompleteAnchor(null);
        setInteractionMap(new Map());
        setFolderMap(new Map());
        if (generalStore.isOpenFromEditor && !projectStore.currentProject?.userDefinedInteractions) {
            const models = loadInteractionModels();
            if (models?.size && !selectedModel) {
                const firstModel = Array.from(models.values())[0];
                setSelectedModel(firstModel);
                await Promise.all([
                    procedureStore.getUserDefinedInteractions(firstModel),
                    projectStore.loadProjectInteractions(null, firstModel.ProjectRef, false)
                ]);
            }
        }
        await reloadInteractions();
    }

    const onClose = () => {
        generalStore.forceStopDataPoll = false;
        modalStore.isSetInteractionsEditorModalOpen = false;
        generalStore.isOpenFromEditor = false;
        generalStore.selectedAnimationModelId = null;
    }

    return (
        <GeneralDialog
            openControl='isSetInteractionsEditorModalOpen'
            className='interactions-manager'
            onEnter={onEnter}
            title={generalStore.translate('manageInteractions')}
            body={renderBody()}
            isConfirmDisabled={true}
            onConfirm={null}
            specialOnClose={onClose}
        />
    );
})

export default InteractionsEditorModal;
